import Toggle, { ToggleSize } from 'common/components/inputs/toggle';
import { useTypedSelector } from 'common/hooks/store';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { togglePoc } from './pocToggleSlice';
import { useAuth } from 'features/auth/hooks/useAuth';
import { selectIsSandboxUser } from 'features/auth/authenticationSlice';

const PocToggle: FC = () => {
  const { isPocModeActive } = useTypedSelector((state) => state.pocToggle);
  const { isSuperUser } = useAuth();
  const isSandboxUser = useSelector(selectIsSandboxUser);

  const dispatch = useDispatch();

  return (
    <>
      {(isSuperUser || isSandboxUser) && (
        <Toggle
          checked={isPocModeActive}
          label=""
          size={ToggleSize.Large}
          identifier="poc-toggle"
          onChange={() => dispatch(togglePoc())}
        />
      )}
    </>
  );
};

export default PocToggle;
